<template>
  <HeaderAppDesktop :class="view.headerClass" />
  <HeaderInternal
    :title="doc.title"
    :backLinkDoc="doc"
    class="header--scroll header--book"
    :class="view.headerClass"
  >
  </HeaderInternal>
</template>

<script setup lang="ts">
import { onBeforeMount, ref } from 'vue'

import { DocView } from '@/models/doc'
import { HeaderView } from '@/models/header'

import HeaderAppDesktop from '@/app/components/header/AppDesktop.vue'
import HeaderInternal from '@/app/components/header/Internal.vue'

const props = defineProps<{
  doc: DocView
}>()

const view = ref(new HeaderView(props.doc))

onBeforeMount(async () => {
  await view.value.init()
})
</script>

<style lang="scss" scoped>
/**
 * The class chaining here is necessary to override the specificity from the `HeaderInternal` styles
 */
.header.header--scroll.header--book {
  padding-top: 22px;

  :deep(*) {
    // `.header--scroll` has a fade in animation, but we don't want it
    // on this component
    animation: none;
  }
}
</style>
